// import Window from "./window";

const config = {
  getBaseUrl: function (): string {
    let url: string = window._env_?.CUSTOMER_URL_ADDRESS || process.env.REACT_APP_CUSTOMER_URL_ADDRESS || "";
    return url;
  },
};

export default config;
